module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.rdata) ? _c('div', {
    staticClass: "page_content"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.rdata.currentPage,
      "page-sizes": _vm.arraySizes,
      "page-size": _vm.rdata.pageSize,
      "layout": _vm.layout,
      "total": _vm.rdata.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47e250c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/paging.vue
// module id = 1032
// module chunks = 0